<template>
  <div>
    <div>
      <div class="card-body">
        <fieldset>
          <legend class="d-flex justify-content-between mb-0">
            <span>
              Jobs
            </span>
          </legend>
        </fieldset>
      </div>

      <div class="preloader-relative" v-if="loading">
        <preloader></preloader>
      </div>

      <template v-else>
        <table class="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Date</th>
              <th>Driver</th>
              <th>Reason</th>
              <th>Completed At</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="jobs?.length">
            <tr :key="key" v-for="(job, key) in jobs">
              <td>
                <span class="badge" :class="jobTypeClass(job)">{{
                  job.type
                }}</span>
              </td>
              <td>{{ job.date | date }}</td>
              <td>{{ job.driver }}</td>
              <td>{{ job.reason }}</td>
              <td>{{ job.completed_at | date(dateTimeFormat) }}</td>
              <td>
                <span
                  class="badge"
                  :class="
                    job.status === 'Completed'
                      ? 'badge-success'
                      : 'badge-danger'
                  "
                  >{{ job.status }}</span
                >
              </td>
              <td>
                <form-button
                  level="primary"
                  :indicator="downloading === job.id"
                  @clicked="download(job)"
                  v-if="job.download_url"
                >
                  Download PDF
                </form-button>
                <router-link
                  class="btn btn-primary"
                  :to="`/jobs/${job.identifier}`"
                >
                  View Job
                </router-link>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="5">
                This job has not been assigned to any runs
              </td>
            </tr>
          </tbody>
        </table>
        <div class="card-footer text-right" v-if="showPagination">
          <pagination
            :data="paginator_data"
            v-on:updateResults="getData"
          ></pagination>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import JobStatus from '@/components/Modules/Job/Children/JobStatus';
import JobLabel from '@/components/Modules/Shared/JobLabel';

export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },
  components: {
    // JobLabel,
    // JobStatus
  },

  data() {
    return {
      loading: true,
      jobs: [],
      paginator_data: null,
      filters: {},
      dateTimeFormat: 'DD/MM/YYYY HH:mm',
      downloading: undefined
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    showPagination() {
      return (
        this.paginator_data?.next_page_url || this.paginator_data?.prev_page_url
      );
    }
  },

  mounted() {
    this.loadJobs();
  },

  methods: {
    loadJobs() {
      this.getData(
        `/fleet/${this.user?.tenant?.identifier}/${this.vehicle.identifier}/jobs`
      );
    },

    getData(url) {
      this.loading = true;

      window.Ajax.get(url)
        .then(response => {
          this.jobs = response.data.data;
          this.paginator_data = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;

          window.toastify.error(
            'Error',
            'Sorry, an error occurred while loading the hires'
          );
        });
    },

    download(job) {
      this.downloading = job.id;

      window.Ajax.download(job.download_url)
        .then(() => (this.downloading = undefined))
        .catch(err => {
          this.downloading = undefined;

          window.toastify.error(
            'Oops',
            'An error occurred while downloading the PDF'
          );
        });
    },

    jobTypeClass(job) {
      switch (job.type_name) {
        case 'hire_delivery':
        case 'client_delivery':
          return 'badge-primary';

        case 'third_party_movement':
          return 'badge-success';

        default:
          return 'badge-warning';
      }
    }
  }
};
</script>
